import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DELIVERY_INFORMATION: "Leveringsinformasjon",
      FILL_IN_YOUR_POSTNUMBER:
        "Fyll inn din adresse for å se leveringsdetaljer.",
      WHEN_DO_YOU_WANT_TO_RECEIVE_FIRST_DELIVERY:
        "Når vil du motta din første levering?",
      HOW_OFTEN_DO_YOU_WANT_DELIVERY: "Hvor ofte vil du ha levering?",
      TELEPHONE_NUMBER_LABEL: "Mobilnummer",
      DOOR_CODE_LABEL: "Kode til oppgang",
      INSTRUCTIONS_TO_DRIVER_LABEL: "Instruksjoner til sjåføren",
      CANCEL_BUTTON: "Avbryt",
      VOLUNTARY_INPUT: "Frivillig",
      EXAMPLE_INSTRUCTIONS_TO_DRIVER:
        "F.eks. “etasje 3” eller “navn på dørklokke”",

      LENGTH_OF_TELEPHONE_NUMBER: 8,

      FIRST_DELIVERY: "Første levering",
      CLOSE: "Lukk",
      CHANGE_START_DATE: "Endre startdato",
      SUBSEQUENT_DELIVERIES: "Påfølgende leveranser",
      CHANGE_DELIVERY_INTERVAL: "Endre leveringsintervall",
      NO_BINDING_TIME: "Ingen bindningstid",
      START_AND_STOP_DELIVERIES: "Start og stopp leveranser når du vil.",
    },
    se: {
      DELIVERY_INFORMATION: "Leveransinformation",
      FILL_IN_YOUR_POSTNUMBER: "Fyll i din adress för att se leveransdetaljer.",
      WHEN_DO_YOU_WANT_TO_RECEIVE_FIRST_DELIVERY:
        "När vill du ta emot din första leverans?",
      HOW_OFTEN_DO_YOU_WANT_DELIVERY: "Hur ofta vill du ha leverans?",
      TELEPHONE_NUMBER_LABEL: "Mobilnummer",
      DOOR_CODE_LABEL: "Portkod",
      INSTRUCTIONS_TO_DRIVER_LABEL: "Instruktioner till chauffören",
      VOLUNTARY_INPUT: "Frivilligt",
      EXAMPLE_INSTRUCTIONS_TO_DRIVER:
        "T.ex. “våningsplan 3” eller “plinga gärna på”",

      LENGTH_OF_TELEPHONE_NUMBER: 10,

      FIRST_DELIVERY: "Första leverans",
      CLOSE: "Stäng",
      CHANGE_START_DATE: "Ändra startdatum",
      SUBSEQUENT_DELIVERIES: "Efterföljande leveranser",
      CHANGE_DELIVERY_INTERVAL: "Ändra leveransintervall",
      NO_BINDING_TIME: "Ingen bindningstid",
      START_AND_STOP_DELIVERIES: "Starta och stoppa leveranser när du vill.",
    },
    dk: {
      DELIVERY_INFORMATION: "Leveringsinformation",
      FILL_IN_YOUR_POSTNUMBER:
        "Indtast din adresse for at se leveringsdetaljer.",
      WHEN_DO_YOU_WANT_TO_RECEIVE_FIRST_DELIVERY:
        "Hvornår ønsker du at modtage din første levering?",
      HOW_OFTEN_DO_YOU_WANT_DELIVERY: "Hvor ofte ønsker du levering?",
      TELEPHONE_NUMBER_LABEL: "Mobilnummer",
      DOOR_CODE_LABEL: "Dørkode",
      INSTRUCTIONS_TO_DRIVER_LABEL: "Instruktioner til chaufføren",
      VOLUNTARY_INPUT: "Frivilligt",
      EXAMPLE_INSTRUCTIONS_TO_DRIVER: "F.eks. “3. etage” eller “ring”",

      LENGTH_OF_TELEPHONE_NUMBER: 8,

      FIRST_DELIVERY: "Første levering",
      CLOSE: "Luk",
      CHANGE_START_DATE: "Ændr starttidspunkt",
      SUBSEQUENT_DELIVERIES: "Efterfølgende leveringer",
      CHANGE_DELIVERY_INTERVAL: "Ændr leveringsinterval",
      NO_BINDING_TIME: "Ingen binding",
      START_AND_STOP_DELIVERIES: "Start og stop leveringer, når du vil.",
    },
  } as const
)[language];
